export class CSmsBase {
    app_key = "ae1bd0a8b32505a86c0b20187f5093ec";
    app_version_name = "7.0.0";
    tel = "";
    timestamp: number;
    constructor(public uuid = "") {}
}
export class CSmsCode extends CSmsBase {
    sms_tmp = "user_identity";
}

export class CSmsCodeLogin extends CSmsBase {
    code = "";
}

export class UserContent {
    name = "";
    nickname = "";
    phone = "";
    id_code = "";
    title = "";
    desc = "";
    smsCode? = "";
    company = "";
    job_title = "";
}

export class LazyList {
    page = 1;
    per = 4;
    all_count = 0;
    hasMore = true;
    searchKey = "";
    list: any[] = [];
}
